module.exports = __webpack_public_path__ + "img/jianhuo-b.0b624c63.svg";